const initPathBlacklist = ["/login", "/wxlogin", "/user", "/login-middleware", "/pay"];

export function getInitRoutePath() {
    let lastPath = sessionStorage.getItem("index-route-path");
    const path = window.location.pathname;
    const search = window.location.search;
    let url = path + search;

    if(initPathBlacklist.includes(path)) {
        if(lastPath) {
            url = lastPath;
        }else {
            url = "/" + search;
        }
    }

    sessionStorage.setItem("index-route-path", url);
    console.log("初始化首页地址为：", url);
}

export function getIndexPathFromStorage() {
    return sessionStorage.getItem("index-route-path") || "/";
}